import React, { useContext, useState } from 'react';
import ThemeContext from '../contexts/ThemeContext';

const ProductsTable = ({ products, handleEdit, handleDelete }) => {
  const { isDark } = useContext(ThemeContext);
  const [searchTerm, setSearchTerm] = useState('');

  // Product name based search filter
  const filteredProducts = products.filter((product) =>
    product.name?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Category wise group panrom
  const grouped = filteredProducts.reduce((acc, product) => {
    const cat = product.category || "Others";
    if (!acc[cat]) acc[cat] = [];
    acc[cat].push(product);
    return acc;
  }, {});

  return (
    <>
      {/* Search Bar */}
      <div className="mb-4">
        <input
          type="text"
          className={`form-control ${isDark ? 'bg-dark text-light border-secondary dark-input' : ''}`}
          placeholder="Search products by name..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {Object.keys(grouped).length === 0 ? (
        <p className={isDark ? 'text-light' : ''}>No products found.</p>
      ) : (
        Object.entries(grouped).map(([category, items]) => (
          <div key={category} className="mb-5">
            <h4 className={`text-capitalize fw-bold border-bottom pb-2 mb-3 ${isDark ? 'text-light' : ''}`}>
              🎆 {category}
            </h4>

            <div style={{ width: '100%', overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
              <table className="table text-center align-middle m-0" style={{ minWidth: '700px' }}>
                <thead>
                  <tr className="text-white bg-dark">
                    <th>IMAGE</th>
                    <th>PRODUCT NAME</th>
                    <th>PACK</th>
                    <th>ORIGINAL PRICE</th>
                    <th>OFFER PRICE</th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((product) => (
                    <tr
                      key={product._id}
                      className={isDark ? 'border-secondary' : 'border-bottom'}
                      style={isDark ? { backgroundColor: '#1e1e1e' } : { backgroundColor: '#ffffff' }}
                    >
                      <td>
                        <img
                          // backend URL-ah append pannaama direct-a product.imageUrl-ai use pannu
                          src={product.imageUrl || 'https://via.placeholder.com/50'}
                          alt={product.name}
                          style={{ width: "50px", height: "50px", borderRadius: "8px", objectFit: "cover" }}
                        />
                      </td>
                      {/* FIX: text color now matches the actual row background —
                          text-dark on white rows, text-light on dark rows */}
                      <td className={`fw-bold ${isDark ? 'text-light' : 'text-dark'}`}>{product.name}</td>
                      <td className={isDark ? 'text-light' : 'text-dark'}>{product.pack}</td>
                      <td className="text-muted text-decoration-line-through">₹{product.originalPrice}</td>
                      <td className="text-danger fw-bold">₹{product.offerPrice}</td>
                      <td>
                        <div className="btn-group btn-group-sm">
                          <button className="btn btn-outline-primary" onClick={() => handleEdit(product)}>Edit</button>
                          <button className="btn btn-danger" onClick={() => handleDelete(product._id)}>Delete</button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        ))
      )}
    </>
  );
};

export default ProductsTable;